import React, { useEffect, useState } from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import BlockUi from 'react-block-ui';
import { connect } from 'react-redux';
import { Loader } from 'react-loaders';
import { Link } from 'react-router-dom';

import {
  getOvernightCampAssociationList,
  getOvernightCampYearList
} from '@redux/overnight-camp-data-yusa-dashboard/action';

import {
  YusaOvernightCampDashboardSelector,
  YusaOvernightCampYearSelector
} from '@redux/overnight-camp-data-yusa-dashboard/selectors';
import GetModulesConfigSelector from '@redux/module-config/selectors';
import { AssociationAdminLoginDetailsSelector } from '@redux/login/selectors';

import { APP_LABELS } from '@config/app-config';
import convertUtcToLocal from '@utilities/ConvertTimezone';
import ErrorPopup from '@modules/employee-data-collection/components/upload-file/error-popup';

import completed from '@static/images/completed.svg';
import NotStarted from '@static/images/NotStarted.svg';
import inporgress from '@static/images/inporgress.svg';
import AssociationsTotal from '@static/images/Association.svg';
import completedhover from '@static/images/completed-hover.svg';
import NotStartedhover from '@static/images/NotStarted-hover.svg';
import inporgresshover from '@static/images/inporgress-hover.svg';
import Associationhover from '@static/images/Association-hover.svg';

import Table from './table';
import ASSOCIATION_COLUMNS from './columns';

const OvernightCampYusaDashboard = props => {
  const {
    YearList,
    AssociationList,
    handleGetYearList,
    LoginUserData,
    ModulesConfigData,
    handleToGetOvernightCampList
  } = props;

  const year =
    ModulesConfigData?.data?.length > 0
      ? get(ModulesConfigData, 'data')?.find(
          o => o?.moduleName === 'Overnight Camp Data'
        )?.year
      : `${new Date().getFullYear()}`;

  const [loader, setLoader] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  const [selectedYear, setSelectedYear] = useState(year);
  const [associationListLoader, setAssociationListLoader] = useState(false);
  const [associationType, setAssociationType] = useState('totalData');
  const [associationData, setAssociationData] = useState({
    totalData: [],
    completed: [],
    NotStarted: [],
    inProgress: []
  });

  useEffect(() => {
    setLoader(true);
    handleGetYearList().then(res => {
      if (res.status === 200) {
        setLoader(false);
      } else {
        setLoader(false);
        setErrorPopup(true);
      }
    });
  }, []);

  useEffect(() => {
    setLoader(true);
    setAssociationListLoader(false);
    window.scrollTo(0, 0);
    handleToGetOvernightCampList(selectedYear).then(res => {
      if (res.status === 200 && res.data.data?.length > 0) {
        setAssociationListLoader(true);
      } else {
        setAssociationListLoader(true);
        setErrorPopup(true);
      }
    });
  }, [selectedYear]);

  useEffect(() => {
    if (associationListLoader) {
      setLoader(false);
    }
  }, [associationListLoader]);

  useEffect(() => {
    if (AssociationList?.data?.length === 0) {
      setAssociationData({
        totalData: [],
        completed: [],
        NotStarted: [],
        inProgress: []
      });
    }
    if (AssociationList && AssociationList?.data?.length > 0) {
      setAssociationData({
        totalData: AssociationList?.data,
        completed: AssociationList?.data?.filter(
          data => data?.Status?.toUpperCase() === APP_LABELS.STATUS_COMPLETED
        ),
        NotStarted: AssociationList?.data?.filter(
          data => data?.Status?.toUpperCase() === APP_LABELS.STATUS_NOT_STARTED
        ),
        inProgress: AssociationList?.data?.filter(
          data => data?.Status?.toUpperCase() === APP_LABELS.STATUS_IN_PROGRESS
        )
      });
    }
  }, [AssociationList]);

  const getDashboardTableCampDataForTable = type =>
    associationData[type]?.map(data => {
      const location = {
        pathname: '/overnight-camp-data/dashboard',
        state: data
      };
      return {
        CampName: `${data.CampName} (${data.BranchNumber})`,
        AssociationName: data.AssociationName,
        YType: data.YType,
        MemberGroup: data.MemberGroup,
        Status: get(data, 'Status', '-'),
        UpdatedDateTime: get(data, 'UpdatedDatetime', null)
          ? convertUtcToLocal(get(data, 'UpdatedDatetime'))
          : '-',
        detailsLink: (
          <Link
            to={location}
            className="table-link"
            onClick={() => {
              sessionStorage.setItem(
                'yusa_selected_camp_branch',
                JSON.stringify(data)
              );
            }}
          >
            {APP_LABELS.DASH_VIEW_DETAILS}
          </Link>
        )
      };
    });

  const handleSelectedYear = selectedValue => {
    setSelectedYear(selectedValue);
  };

  return (
    <>
      <BlockUi
        blocking={loader}
        message="Loading, please wait"
        loader={<Loader active type="semi-circle-spin" />}
      >
        <main className="page-container">
          <div className="ymca-data-wrapper dashboard-wrapper">
            <div className="container">
              <section className="dashboard-header">
                <div className="row align-items-center">
                  <div className="col-lg-11 col-md-6 col-sm-12">
                    <div className="user-name custom-username">
                      <div className="row">
                        <div className="col-lg-12">
                          <h6>{APP_LABELS.WELCOME}</h6>
                          <h2 className="ymca-sub-heading mb-0 notranslate">
                            {`${get(
                              LoginUserData,
                              'user.firstName',
                              'User'
                            )} ${get(LoginUserData, 'user.lastName', '')}`}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="select-date ms-auto">
                    <span>Select Year:</span>
                    <select
                      className="form-select form-select-sm year-picker"
                      aria-label=".form-select-sm example"
                      name="selectYear"
                      value={selectedYear}
                      onChange={e => handleSelectedYear(e.target.value)}
                    >
                      {YearList?.data &&
                        YearList?.data?.sort()?.map(data => (
                          <option key={data} value={data}>
                            {data}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </section>

              <section className="stats-data">
                <div className="row justify-content-center">
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <button
                      type="button"
                      className="card stats-card associations ymca-associate w-100"
                      onClick={() => setAssociationType('totalData')}
                    >
                      <div className="d-flex align-items-center h-100">
                        <div className="card-icon">
                          <img
                            src={AssociationsTotal}
                            className="dark-icon"
                            alt="icon"
                          />
                          <img
                            src={Associationhover}
                            className="light-icon"
                            alt="icon"
                          />
                        </div>
                        <div className="card-title">
                          <h4>
                            {AssociationList
                              ? AssociationList?.data?.length
                              : 0}
                          </h4>
                          <p> Overnight Camps</p>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <button
                      type="button"
                      className="card stats-card branches ymca-completed w-100"
                      onClick={() => setAssociationType('completed')}
                    >
                      <div className="d-flex align-items-center h-100">
                        <div className="card-icon">
                          <img
                            src={completed}
                            className="dark-icon"
                            alt="icon"
                          />
                          <img
                            src={completedhover}
                            className="light-icon"
                            alt="icon"
                          />
                        </div>
                        <div className="card-title">
                          <h4>
                            {AssociationList
                              ? AssociationList?.data?.filter(
                                  data =>
                                    data?.Status?.toUpperCase() ===
                                    APP_LABELS.STATUS_COMPLETED
                                )?.length
                              : 0}
                          </h4>
                          <p>Completed</p>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <button
                      type="button"
                      className="card stats-card profiles ymca-progress w-100"
                      onClick={() => setAssociationType('inProgress')}
                    >
                      <div className="d-flex align-items-center h-100">
                        <div className="card-icon">
                          <img
                            src={inporgress}
                            className="dark-icon"
                            alt="icon"
                          />
                          <img
                            src={inporgresshover}
                            className="light-icon"
                            alt="icon"
                          />
                        </div>
                        <div className="card-title">
                          <h4>
                            {AssociationList
                              ? AssociationList?.data?.filter(
                                  data =>
                                    data?.Status?.toUpperCase() ===
                                    APP_LABELS.STATUS_IN_PROGRESS
                                )?.length
                              : 0}
                          </h4>
                          <p>In Progress</p>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <button
                      type="button"
                      className="card stats-card programs ymca-notStarted w-100"
                      onClick={() => setAssociationType('NotStarted')}
                    >
                      <div className="d-flex align-items-center h-100">
                        <div className="card-icon">
                          <img
                            src={NotStarted}
                            className="dark-icon"
                            alt="icon"
                          />
                          <img
                            src={NotStartedhover}
                            className="light-icon"
                            alt="icon"
                          />
                        </div>
                        <div className="card-title">
                          <h4>
                            {AssociationList
                              ? AssociationList?.data?.filter(
                                  data =>
                                    data?.Status?.toUpperCase() ===
                                    APP_LABELS.STATUS_NOT_STARTED
                                )?.length
                              : 0}
                          </h4>
                          <p>Not Started</p>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </section>
            </div>

            <hr className="custom-hr mt-0" />
            <Table
              rows={getDashboardTableCampDataForTable(associationType)}
              headers={ASSOCIATION_COLUMNS}
              associationType={associationType}
              setLoader={setLoader}
              setErrorPopup={setErrorPopup}
              year={selectedYear}
            />
          </div>
        </main>
        <ErrorPopup
          handleCloseErrorPopup={() => {
            setErrorPopup(false);
          }}
          errorMessage={APP_LABELS.COMMON_ERROR_MESSAGE}
          showErrorPopup={errorPopup}
        />
      </BlockUi>
    </>
  );
};

OvernightCampYusaDashboard.propTypes = {
  handleGetYearList: PropTypes.func.isRequired,
  handleToGetOvernightCampList: PropTypes.func.isRequired,

  YearList: PropTypes.objectOf(PropTypes.any).isRequired,
  AssociationList: PropTypes.objectOf(PropTypes.any).isRequired,

  LoginUserData: PropTypes.objectOf(PropTypes.any).isRequired,
  ModulesConfigData: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapDispatchToProps = {
  handleGetYearList: getOvernightCampYearList,
  handleToGetOvernightCampList: getOvernightCampAssociationList
};

const mapStateToProps = state => ({
  YearList: YusaOvernightCampYearSelector(state),
  AssociationList: YusaOvernightCampDashboardSelector(state),

  ModulesConfigData: GetModulesConfigSelector(state),
  LoginUserData: AssociationAdminLoginDetailsSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OvernightCampYusaDashboard);
